<template>
  <div class="container">
    <div class="row mt-3 justify-content-center">
      <div class="col-lg-8">
        <div v-if="visible" class="card info-card">
          <span class="title-and-close-button">
              <p class="title">Inhoud niet gevonden</p>
          </span>
          <p class="body">De inhoud die je probeert raad te plegen lijkt niet te bestaan of is momenteel niet
            beschikbaar.</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>


  export default {
    name: "NotFound",
    components: {},
    props: {
      info: Object
    },
    mixins: [],
    methods: {},
    data() {
      return {
        visible: true
      }
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  .info-card {
    display: flex;
    flex-direction: column;
    padding: 21px;
    width: 100%;

    .title-and-close-button {
      display: flex;
      justify-content: center;
    }

    .title {
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 0.3rem;
      text-align: center;
    }

    .body {
      font-size: 0.9rem;
      margin-bottom: 0.3rem;
      text-align: center;
    }

    .close-button {
      background-color: $primary-blue;
      border-radius: 15px;
      padding: 0rem 0.55rem;
      max-height: 1.8rem;
      font-size: 0.8rem;
      color: $font-light;
      position: relative;
      top: -10px;
    }

    @media screen and (max-width: $large) {
      width: auto;
      margin: 0 1rem;

    }
  }

</style>